import { render, staticRenderFns } from "./PlaceAutocompleteList.vue?vue&type=template&id=2f123c5a&"
import script from "./PlaceAutocompleteList.vue?vue&type=script&lang=js&"
export * from "./PlaceAutocompleteList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports